export const PAGINATION = {
	SIZE: 50
}